import * as React from 'react';
import { connect } from 'react-redux';
import { IHttpApi } from '@cian/http-api';
import { IState } from '../../store';

import { QuizComponent } from './QuizComponent';
import { getDealType, FDealType } from '../../utils/deal_type';

export interface IQuizContainer {
  isQuizEnabled: boolean;
  isForbiddenType: boolean;
  subdomain: string;
  httpApi: IHttpApi;
}

export interface IOwnProps {
  httpApi: IHttpApi;
}

const Quiz: React.FC<IQuizContainer> = ({ subdomain, isQuizEnabled, isForbiddenType, httpApi }) => {
  if ((typeof window !== 'undefined' && !document.referrer.includes('cian.ru')) || !isQuizEnabled || isForbiddenType) {
    return null;
  }

  return <QuizComponent subdomain={subdomain} httpApi={httpApi} />;
};

export const mapStateToProps = (state: IState, ownProps: IOwnProps): IQuizContainer => {
  const {
    offerData: { offer },
    pageData: { subdomain },
    isQuizEnabled,
  } = state;
  const { httpApi } = ownProps;
  const dealType = getDealType(offer);
  const isForbiddenType = FDealType.RentDaily === dealType;

  return {
    subdomain,
    isQuizEnabled,
    isForbiddenType,
    httpApi,
  };
};

export const QuizContainer = connect<IQuizContainer, {}, IOwnProps>(mapStateToProps)(Quiz);
